import { render, staticRenderFns } from "./lensesType.vue?vue&type=template&id=3fdfdc6b&scoped=true"
import script from "./lensesType.vue?vue&type=script&lang=js"
export * from "./lensesType.vue?vue&type=script&lang=js"
import style0 from "./lensesType.vue?vue&type=style&index=0&id=3fdfdc6b&prod&lang=scss&scoped=true"
import style1 from "./lensesType.vue?vue&type=style&index=1&id=3fdfdc6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdfdc6b",
  null
  
)

export default component.exports